<div class="lum-filters__wrapper">
  <div class="lum-filter-group flex gap-x-10 grow-0 shrink-0">
    <ng-container
      *ngFor="
        let filter of filteredFilters;
        let idx = index;
        trackBy: trackByFilterId
      "
      [ngSwitch]="filter.type"
    >
      <div class="lum-filter-item__container mb-3" [ngClass]="filter.type">
        <!-- input -->
        <ng-template ngSwitchCase="input">
          <input
            type="text"
            [(ngModel)]="values[filter.id]"
            [placeholder]="filter.label"
            matInput
            class="lum-input"
            (input)="onInputChange(filter.id, $event)"
          />
        </ng-template>

        <!-- checkbox -->
        <ng-template ngSwitchCase="checkbox">
          <mat-checkbox
            [checked]="values[filter.id] == 1"
            class="lum-checkbox text-small"
            (change)="onCheckboxChange(filter.id, $event)"
          >
            {{ filter.label }}
          </mat-checkbox>
        </ng-template>

        <!-- select -->
        <ng-template ngSwitchCase="select">
          <mat-select
            [(ngModel)]="values[filter.id]"
            class="lum-select"
            [placeholder]="filter.label"
            [disabled]="filter?.disabled || false"
            (selectionChange)="onEmitChange(filter.id, $event)"
          >
            <mat-option value="">--None--</mat-option>
            <mat-option *ngFor="let type of filter?.options" [value]="type.value">
              {{ type.label }}
            </mat-option>
          </mat-select>
        </ng-template>

        <!-- Date Picker -->
        <ng-template ngSwitchCase="date">
          <div class="lum-datepicker__filter">
            <input
              matInput
              readonly
              class="lum-input"
              [(ngModel)]="values[filter.id]"
              [placeholder]="filter.label"
              [matDatepicker]="orderDatepicker"
              (dateChange)="onDateChange(filter.id, $event)"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="orderDatepicker"
            ></mat-datepicker-toggle>
            <mat-datepicker-toggle
              *ngIf="values[filter.id]"
              class="lum-datepicker__clear"
              matSuffix
              (click)="onClearDate(filter)"
            >
              <lum-ui-icon
                matDatepickerToggleIcon
                icon="close"
                [width]="18"
                [height]="18"
                color="#000000"
              ></lum-ui-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #orderDatepicker></mat-datepicker>
          </div>
        </ng-template>

        <!-- category -->
        <ng-template ngSwitchCase="category">
          <lum-filter-category
            [value]="values[filter.id]"
            [label]="filter.label"
            [isSubcategory]="filter.config?.isSubcategory || false"
            (onCategorySelect)="onEmitChange(filter.id, $event)"
          ></lum-filter-category>
        </ng-template>

        <!-- tags -->
        <ng-template ngSwitchCase="tags">
          <lum-filter-tag
            label=""
            [value]="values[filter.id] || []"
            [placeholder]="filter.label"
            [inlineChips]="filter.config?.inlineChips || false"
            (onFilterSelect)="onTagFilterSelect(filter.id, $event)"
          ></lum-filter-tag>
        </ng-template>

        <!-- locations -->
        <ng-template ngSwitchCase="locations">
          <lum-filter-locations
            label=""
            [value]="values[filter.id] || []"
            [placeholder]="filter.label"
            [inlineChips]="filter.config?.inlineChips || false"
            (onFilterSelect)="onLocationFilterSelect(filter.id, $event)"
          ></lum-filter-locations>
        </ng-template>

        <!-- users -->
        <ng-template ngSwitchCase="users">
          <lum-filter-user
            label=""
            [value]="values[filter.id]"
            [placeholder]="filter.label"
            (selectUser)="onEmitChange(filter.id, $event)"
          ></lum-filter-user>
        </ng-template>

        <!-- Remove Filter -->
        <div class="lum-filter--remove__container">
          <lum-ui-icon
            class="cursor-pointer"
            icon="close-circle"
            width="22"
            height="22"
            color="#DB3A50"
            (click)="onRemoveFilter(idx)"
          ></lum-ui-icon>
        </div>
      </div>
    </ng-container>
    <div class="lum-filter-actions__container grow-0 shrink-0 px-2">
      <button
        type="button"
        class="lum-button"
        [ngClass]="buttonClass"
        [matMenuTriggerFor]="menu"
      >
        <lum-ui-icon
          [color]="buttonIconColor"
          icon="funnel"
          class="mr-2"
        ></lum-ui-icon>
        Add Filter
      </button>

      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <ng-container *ngFor="let filter of displayFilters; trackBy: trackByValue">
          <mat-checkbox
            #menuItems
            class="lum-checkbox lum-checkbox--menu  d-block py-3 hover:gray-100"
            name="menu_filters"
            [checked]="filter.show"
            (change)="onSelectMenu($event, filter)"
          >
            {{ filter.label }}
          </mat-checkbox>
        </ng-container>
      </mat-menu>
    </div>
  </div>
</div>
